<template>
  <div class="col-12 p-0 m-0">
    <div class="position-relative flex-wrap m-0 mt-2 w-100" ref="supplierProductSku">
      <Select :source="`vendor-account/${mapping.vendor_id}/product-sku-in-vendor-account`" placeholder="Product Sku" :value="mapping.product_sku" @changeValue="handleProductSkuCarrierAccount" class="flex-1 mr-2"></Select>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      storeProduct: []
    }
  },
  created() {
    setTimeout(() => {
      this.$emit('changeValue', {
        is_valid: 1,
        store_id: ''
      })
    }, 200)
  },
  computed: {
    storeId() {
      return this.config?.storeId
    },
    data() {
      return this.config?.data
    },
    mapping() {
      return Object.assign({}, this.data.mapping, this.config?.mapping)
    }
  },
  methods: {
    handleProductSkuCarrierAccount(value) {
      if (this.mapping.vendor_id && value != '') {
        this.$emit('changeValue', {
          store_id: String(this.mapping.store_id || ''),
          product_sku: value,
          is_valid: true
        })
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
